// src/components/Login.js

import React, { useState } from 'react';
import { signInWithEmailAndPassword } from 'firebase/auth';
import { auth } from '../firebase'; // Sadece 'auth' importu yeterli
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import logo from '../assets/logo.png';
import { Box, Paper, Typography, TextField, Button, CircularProgress } from '@mui/material';

const Login = () => {
  const [email, setEmail] = useState(''); 
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { currentUser } = useAuth();

  if (currentUser) { return <Navigate to="/" />; }

  const handleLogin = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    if (!email || !password) {
        setError('Lütfen tüm alanları doldurun.');
        setLoading(false);
        return;
    }

    try {
      await signInWithEmailAndPassword(auth, email, password);
    } catch (err) {
      console.error("Giriş sırasında hata oluştu:", err);
      setError('Giriş başarısız. Lütfen bilgilerinizi kontrol edin.');
    }
    setLoading(false);
  };

  return (
    <>
      <div className="login-background"></div>
      <div className="login-overlay"></div>
      <Box sx={{
          height: '100vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          position: 'relative',
          zIndex: 1,
        }}>
        <Paper component="form" onSubmit={handleLogin} sx={{ p: 4, width: '100%', maxWidth: '400px', display: 'flex', flexDirection: 'column', gap: 2 }}>
          <Box component="img" src={logo} alt="Solar Gard Master Garage Logo" sx={{ maxHeight: '60px', mb: 2, alignSelf: 'center' }} />
          <Typography variant="h5" component="h1" align="center" gutterBottom>
            Solar Gard Master Garage CRM
          </Typography>
          <TextField 
            label="E-posta Adresi" 
            type="email"
            value={email} 
            onChange={(e) => setEmail(e.target.value)} 
            required 
            autoFocus
          />
          <TextField 
            label="Şifre" 
            type="password" 
            value={password} 
            onChange={(e) => setPassword(e.target.value)} 
            required 
          />
          {error && <Typography color="error" align="center">{error}</Typography>}
          <Button type="submit" variant="contained" size="large" disabled={loading}>
            {loading ? <CircularProgress size={24} /> : 'Giriş Yap'}
          </Button>
        </Paper>
      </Box>
    </>
  );
};

export default Login;
